import { render, staticRenderFns } from "./AddSaleQuotation.vue?vue&type=template&id=28c88ecf&"
import script from "./AddSaleQuotation.vue?vue&type=script&lang=js&"
export * from "./AddSaleQuotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\laravel\\rawal\\rawal-laravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28c88ecf')) {
      api.createRecord('28c88ecf', component.options)
    } else {
      api.reload('28c88ecf', component.options)
    }
    module.hot.accept("./AddSaleQuotation.vue?vue&type=template&id=28c88ecf&", function () {
      api.rerender('28c88ecf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/AddSaleQuotation.vue"
export default component.exports